import { VOICE_PROVIDERS } from '@nava/voice-providers';
import { z } from 'zod';
export const UuidSchema = z.string().guid();
/** The voice vendor a session's conversation ran on, from `@nava/voice-providers`. */
export const ConversationProviderSchema = z.enum(VOICE_PROVIDERS);
/** How the participant took part: talking out loud, or a text-only chat. */
export const ConversationModeSchema = z.enum(['voice', 'chat']);
export const IsoDateTimeSchema = z.string().datetime({ offset: true });
export const VoiceSchema = z.enum([
    'alloy',
    'ash',
    'ballad',
    'coral',
    'echo',
    'sage',
    'shimmer',
    'verse',
]);
export const SessionStatusSchema = z.enum([
    'scheduled',
    'waiting',
    'connecting',
    'active',
    'completed',
    'failed',
    'abandoned',
    'analysis_pending',
    'analysis_processing',
    'analyzed',
    'analysis_failed',
]);
export const QualityResultStatusSchema = z.enum(['completed', 'incomplete', 'invalid']);
export const QualityStatusSchema = z.enum([
    'not_assessed',
    'not_applicable',
    'pending',
    'completed',
    'incomplete',
    'invalid',
]);
export const TokenUsageSchema = z.record(z.string(), z.unknown());
//# sourceMappingURL=common.js.map